import React, { useCallback, useEffect } from 'react'

import { useAppContext, View } from 'context/AppContext'
import LeaderBoard from 'views/pages/LeaderBoard'
import Race from 'views/pages/Race'
import './AppLayout.scss'
import Share from 'views/pages/Share'
import Modal from 'views/components/Modal'
import { ReactComponent as FlagIcon } from 'assets/icons/flag.svg'
import { ReactComponent as CupIcon } from 'assets/icons/cup.svg'
import { ReactComponent as ShareIcon } from 'assets/icons/share.svg'
import SplashScreen from 'views/pages/SplashScreen'

const tabs = [
  {
    name: View.RACE,
    icon: <FlagIcon className="icon" />,
  },
  { name: View.LEADERBOARD, icon: <CupIcon className="icon" /> },
  { name: View.SHARE, icon: <ShareIcon className="icon" /> },
]

const AppLayout: React.FC = () => {
  const {
    view,
    setView,
    isModalOpen,
    priceRange,
    betResult,
    percentageChange,
    setIsModalOpen,
    setBetResult,
    customer,
    showSplashScreen,
  } = useAppContext()

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setView(event.currentTarget.name as View)
  }

  const handleClose = useCallback(() => {
    setIsModalOpen(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (betResult) setIsModalOpen(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [betResult])

  useEffect(() => {
    if (!isModalOpen) return

    let timer: NodeJS.Timeout

    timer = setTimeout(() => {
      setIsModalOpen(false)
      setBetResult(null)
    }, 3000)

    return (): void => clearTimeout(timer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalOpen])

  if (showSplashScreen) return <SplashScreen />

  if (!customer) return null

  return (
    <div className={`AppLayout ${isModalOpen ? 'blur' : ''}`}>
      <div className="AppLayout__page-wrapper">
        {view === View.RACE && <Race />}
        {view === View.LEADERBOARD && <LeaderBoard />}
        {view === View.SHARE && <Share />}
      </div>

      <div className="AppLayout__action-bar-wrapper">
        <div className="AppLayout__action-bar">
          {tabs.map((tab) => (
            <button
              key={tab.name}
              name={tab.name}
              className={`AppLayout__action-bar-button ${view === tab.name ? 'active' : ''}`}
              onClick={handleClick}
              aria-label={tab.name}
            >
              {tab.icon}
              <span className="AppLayout__action-bar-button-label">
                {tab.name}
              </span>
            </button>
          ))}
        </div>
      </div>

      <Modal
        open={isModalOpen}
        onClose={handleClose}
        priceRange={priceRange}
        betResult={betResult}
        percentageChange={percentageChange}
      />
    </div>
  )
}

export default AppLayout
